/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-vars: 0, no-use-before-define: 0, no-var: 0 */
/* globals _, mp */

/*
 * Provides:
 *  mp.widgets.dropdowns.Checkbox
 *
 * Requires:
 *  mp.widgets.Dropdown
 */

_.namespace(`mp.widgets.dropdowns`, function(ns) {
  'use strict';
  function Checkbox() {
    this.class_name = `mp_checkbox_dropdown`;
    this.label_class = Label;
    this.body_class = Body;
  }
  _.inherit(Checkbox, mp.widgets.Dropdown);

  Checkbox.prototype.create = function() {
    Checkbox.superclass.create.apply(this, arguments);

    this.selected_items = [];
    this.update_width();

    return this;
  };

  Checkbox.prototype.bindings = function() {
    Checkbox.superclass.bindings.call(this);

    this.container.bind(`label-activated`, _.bind(this.update_width, this));

    this.body.container.bind(`dropdown-item-deselected`, _.bind(function(ev, item) {
      this.selected_items = _.without(this.selected_items, item);
      this.update_label();
      this.container.trigger(`item-deselected`, item);
    }, this));
  };

  Checkbox.prototype.select_values = function(values, skip_event) {
    _.each(values, function(val) {
      this.select_val(val, skip_event);
    }, this);
  };

  Checkbox.prototype.select_item = function(item, skip_event) {
    if (item.selected && !this.config.menu) {
      return;
    }

    this.selected_items.push(item);

    this.update_label(skip_event);
    this.body.select_item(item, skip_event);
  };

  Checkbox.prototype.update_label = function(skip_event) {
    if (this.config.emulate_select) {
      this.label.select(this.selected_items, skip_event);
    }
    this.update_width();
  };

  Checkbox.prototype.update = function(values) {
    this.body.fill(values);
  };

  Checkbox.prototype.update_width = function() {
    var label_width = this.label.container.width();
    this.body.container.css(`width`, `auto`);
    if (this.body.container.width() < label_width) {
      this.body.container.width(label_width);
    }
  };

  Checkbox.prototype.default_config = function() {
    return _.extend(Checkbox.superclass.default_config.call(this), {
      emulate_select: true,
    });
  };

  Checkbox.prototype.deactivate = function(ev) {
    // We want to keep the dropdown open while they are
    // clicking
    if (ev && ev.type === `dropdown-item-selected`) {
      return;
    }
    Checkbox.superclass.deactivate.call(this);
  };

  Checkbox.prototype.onchange = function(callback) {
    var _this = this;
    this.container.bind(`item-selected`, function(ev, item) {
      callback(_this.selected_items);
    });
    this.container.bind(`item-deselected`, function(ev, item) {
      callback(_this.selected_items);
    });
  };

  Checkbox.prototype._item_selected = function(ev, item) {
    this.select_item(item);
  };

  function Label() {
  }
  _.inherit(Label, mp.widgets.Dropdown.Label);

  Label.prototype.select = function(items, skip_event) {
    this.value = (_.isArray(items) ? _.map(items, function(i) { return i.val(); }) : []);
    if (typeof(items) === `string` && !this.default_title) { this.default_title = items; }

    this._set_content(items);

    if (!skip_event) { this.container.trigger(`label-changed`, this); }

    return this;
  };

  Label.prototype._set_content = function(items) {
    var title_text;
    if (!_.isArray(items) || items.length === 0) {
      title_text = this.default_title;
    } else if (items.length === 1) {
      title_text = typeof(items[0]) === `string` ? items[0] : items[0].title();
    } else {
      title_text = items.length + ` selected`;
    }

    Label.superclass._set_content.call(this, title_text);
  };


  function Body() {
    this.item_class = Item;
  }
  _.inherit(Body, mp.widgets.Dropdown.Body);

  Body.prototype.select_item = function(item, skip_event) {
    item.select(false);
    if (!skip_event) {
      this.container.trigger(`item-selected`, item);
    }
  };


  function Item() {
    this.class_name = `checkbox_dropdown_item`;
  }
  _.inherit(Item, mp.widgets.Dropdown.Item);

  Item.prototype.default_config = function() {
    return {
    };
  };

  Item.prototype.create = function(div, config) {
    Item.superclass.create.call(this, div, config);

    this.content = $(`<span>`);
    this.container.append(this.content);

    return this;
  };

  Item.prototype._set_content = function(item) {
    if (_.isArray(item)) {
      this.display_value = item[1];
    } else {
      this.display_value = item;
    }
    if (this.config.raw_html_item_labels) {
      this.content.html(this.display_value);
    } else {
      this.content.text(this.display_value);
    }
    this.content.attr(`title`, this.title());
  };

  Item.prototype.title = function() {
    return this.display_value;
  };

  Item.prototype.select = function(change) {
    // This is called on mousedown
    if (this.selected) {
      this.deselect();
    } else {
      Item.superclass.select.call(this, change);
    }
  };

  Item.prototype.deselect = function(skip_event) {
    Item.superclass.deselect.call(this);
    if (!skip_event) {
      this.container.trigger(`dropdown-item-deselected`, this);
    }
  };

  Checkbox.Label = Label;
  Checkbox.Body = Body;
  Checkbox.Item = Item;

  return {
    Checkbox,
  };
});

}.call(window));